export type DeviceTier = "high" | "medium" | "low"

export function classifyTier(): DeviceTier {
  if (typeof window === "undefined") return "low"
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  if (reduced) return "low"

  const canvas = document.createElement("canvas")
  const webgl2 = Boolean(canvas.getContext("webgl2"))
  const cores = navigator.hardwareConcurrency || 4
  const touch = window.matchMedia("(pointer: coarse)").matches
  const dpr = window.devicePixelRatio || 1

  if (!webgl2 || cores < 4) return "low"
  if (touch || cores < 8 || dpr > 2) return "medium"
  return "high"
}
